import { render, staticRenderFns } from "./BlockedIpTable.vue?vue&type=template&id=6b8373a2&scoped=true&"
import script from "./BlockedIpTable.vue?vue&type=script&lang=js&"
export * from "./BlockedIpTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8373a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8373a2')) {
      api.createRecord('6b8373a2', component.options)
    } else {
      api.reload('6b8373a2', component.options)
    }
    module.hot.accept("./BlockedIpTable.vue?vue&type=template&id=6b8373a2&scoped=true&", function () {
      api.rerender('6b8373a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Security/BlockedIp/BlockedIpTable.vue"
export default component.exports